// E.4: presety branżowe konfiguracji magazynu — czysty moduł (bez React/axios/localStorage),
// wzorzec utils/bundlePresets.js: dane + builder, klik w UI TYLKO prefilluje formularz
// (InventorySettings.js), zapis idzie istniejącym auto-save.
//
// P8.1d: granica „UI vs dane" biegnie WEWNĄTRZ tego pliku i jest celowa.
// `nameKey`/`descriptionKey` presetu to TYTUŁ I PODTYTUŁ KAFELKA — czyste UI, więc klucze
// i18n (obok istniejących `inventoryPresets.*`: cardTitle, cardSub, applied…).
// `customColumns[].label/description/example/options` oraz `suggestedTypes` zostają
// LITERALNYM PL, bo to DANE, nie napisy: applyPreset przepuszcza je do stanu, a
// `toServerPayload` zapisuje label jako `inventory_field_settings.label` (backend buduje
// z niego nagłówki szablonu importu), zaś suggestedTypes trafiają do GLOBALNEGO słownika
// `Type` — bez `organization_id`, więc niemiecka nazwa typu zanieczyściłaby słownik
// wszystkich organizacji SaaS-a naraz.
//
// Moduł bez importów: backendowy tests/demoPresets.test.js wykonuje ten plik w `vm` (lustro presetów
// w modules/demoPresets.js). Wyprowadzone listy kluczy stoją w utils/inventoryFieldDefs.js.

export const INVENTORY_PRESETS = [
  {
    key: 'ski',
    nameKey: 'inventoryPresets.ski.name',
    descriptionKey: 'inventoryPresets.ski.desc',
    visibleColumns: ['category', 'brand', 'name', 'size', 'inventory_number', 'status', 'sku', 'condition', 'location', 'price', 'bail'],
    requiredFields: [],
    customColumns: [
      { key: 'ski_length_cm', label: 'Długość (cm)', description: 'Długość nart lub deski w centymetrach', example: '165', fieldType: 'number', sizeField: true },
      { key: 'boot_size', label: 'Rozmiar butów (Mondopoint)', description: 'Rozmiar butów narciarskich lub snowboardowych', example: '27.5', fieldType: 'text', sizeField: true },
    ],
    suggestedTypes: ['Narty', 'Buty narciarskie', 'Kije', 'Snowboard', 'Buty snowboardowe', 'Kask'],
  },
  {
    key: 'bikes',
    nameKey: 'inventoryPresets.bikes.name',
    descriptionKey: 'inventoryPresets.bikes.desc',
    visibleColumns: ['category', 'brand', 'name', 'inventory_number', 'status', 'sku', 'condition', 'location', 'sizeRange', 'price', 'bail'],
    requiredFields: ['sizeRange'],
    customColumns: [
      { key: 'frame_number', label: 'Numer ramy', description: 'Numer seryjny ramy roweru', example: 'WBK-2024-00123', fieldType: 'text' },
      { key: 'wheel_size', label: 'Rozmiar koła', description: 'Średnica koła', example: '29"', fieldType: 'list', options: ['26"', '27.5"', '29"', '700c'], sizeField: true },
    ],
    suggestedTypes: ['Rower górski', 'Rower miejski', 'Rower elektryczny', 'Rower dziecięcy'],
  },
  {
    key: 'water',
    nameKey: 'inventoryPresets.water.name',
    descriptionKey: 'inventoryPresets.water.desc',
    visibleColumns: ['category', 'brand', 'name', 'size', 'inventory_number', 'status', 'condition', 'location', 'price', 'bail'],
    requiredFields: [],
    customColumns: [
      { key: 'capacity_persons', label: 'Liczba osób', description: 'Maksymalna liczba osób', example: '2', fieldType: 'number' },
      { key: 'paddle_included', label: 'Wiosło w zestawie', description: 'Czy wiosło jest częścią zestawu', example: 'Tak', fieldType: 'list', options: ['Tak', 'Nie'] },
    ],
    suggestedTypes: ['Kajak jednoosobowy', 'Kajak dwuosobowy', 'Deska SUP', 'Kamizelka asekuracyjna'],
  },
  {
    key: 'tools',
    nameKey: 'inventoryPresets.tools.name',
    descriptionKey: 'inventoryPresets.tools.desc',
    visibleColumns: ['category', 'brand', 'name', 'inventory_number', 'status', 'sku', 'condition', 'location', 'maintenanceDate', 'price', 'bail'],
    requiredFields: ['condition', 'maintenanceDate'],
    customColumns: [
      { key: 'power_source', label: 'Zasilanie', description: 'Rodzaj zasilania urządzenia', example: 'Elektryczne 230V', fieldType: 'list', options: ['Elektryczne 230V', 'Akumulatorowe', 'Spalinowe', 'Pneumatyczne'] },
      { key: 'next_inspection_date', label: 'Data następnego przeglądu', description: 'Termin obowiązkowego przeglądu technicznego', example: '2026-12-01', fieldType: 'date' },
    ],
    suggestedTypes: ['Wiertarka udarowa', 'Szlifierka kątowa', 'Zagęszczarka gruntu', 'Rusztowanie'],
  },
  {
    key: 'vehicles',
    nameKey: 'inventoryPresets.vehicles.name',
    descriptionKey: 'inventoryPresets.vehicles.desc',
    visibleColumns: ['category', 'brand', 'name', 'inventory_number', 'status', 'condition', 'location', 'purchaseDate', 'price', 'bail'],
    requiredFields: ['condition'],
    customColumns: [
      { key: 'registration_number', label: 'Numer rejestracyjny', description: 'Tablice rejestracyjne pojazdu lub przyczepy', example: 'KR 12345', fieldType: 'text' },
      { key: 'insurance_valid_until', label: 'Ważność ubezpieczenia', description: 'Data końca polisy OC/AC', example: '2026-12-31', fieldType: 'date' },
    ],
    suggestedTypes: ['Przyczepa lekka', 'Przyczepa kempingowa', 'Samochód dostawczy', 'Laweta'],
  },
  {
    key: 'events',
    nameKey: 'inventoryPresets.events.name',
    descriptionKey: 'inventoryPresets.events.desc',
    visibleColumns: ['category', 'brand', 'name', 'inventory_number', 'status', 'condition', 'location', 'tags', 'price', 'bail'],
    requiredFields: [],
    customColumns: [
      { key: 'setup_time_minutes', label: 'Czas montażu (min)', description: 'Szacowany czas montażu na miejscu', example: '30', fieldType: 'number' },
      { key: 'power_requirement', label: 'Wymagane zasilanie', description: 'Zapotrzebowanie na prąd', example: '230V / 16A', fieldType: 'text' },
    ],
    suggestedTypes: ['Namiot eventowy', 'Nagłośnienie', 'Oświetlenie sceniczne', 'Stoły i krzesła'],
  },
];

export function getPresetByKey(key) {
  return INVENTORY_PRESETS.find((p) => p.key === key) || null;
}

// current: { visibleColumns, requiredFields, customColumns }.
// options.baseRequiredFields: pola zawsze wymagane w InventorySettings.js (NIE duplikujemy
// tej listy tutaj — wołający przekazuje swoją stałą `baseRequiredFields`).
// options.reservedKeys: klucze kolumn wbudowanych/opcjonalnych (BUILT_IN_COLUMNS ∪
// OPTIONAL_EXTRA_COLUMNS) — kolumna własna presetu o takim kluczu jest pomijana.
//
// visibleColumns/requiredFields są CZYSTĄ funkcją presetu (+ baseRequiredFields) — nie
// zależą od `current`, więc kolejne zastosowanie tego samego presetu daje ten sam wynik
// (idempotencja). customColumns MERGE'uje się z istniejącymi po kluczu (nigdy nie nadpisuje
// już istniejącej definicji — ani wbudowanej, ani własnej dodanej wcześniej).
export function applyPreset(preset, current = {}, options = {}) {
  if (!preset || !preset.key) return current;

  const baseRequiredFields = Array.isArray(options.baseRequiredFields) ? options.baseRequiredFields : [];
  const reservedKeys = new Set(Array.isArray(options.reservedKeys) ? options.reservedKeys : []);

  const presetCustom = Array.isArray(preset.customColumns) ? preset.customColumns : [];
  const existingCustom = Array.isArray(current.customColumns) ? current.customColumns : [];
  const existingCustomKeys = new Set(existingCustom.map((c) => c.key));

  const newCustom = presetCustom.filter((c) => c && c.key && !reservedKeys.has(c.key) && !existingCustomKeys.has(c.key));
  const customColumns = [...existingCustom, ...newCustom];

  const presetCustomKeys = presetCustom.filter((c) => c && c.key && !reservedKeys.has(c.key)).map((c) => c.key);
  const visibleColumns = Array.from(new Set([
    ...(Array.isArray(preset.visibleColumns) ? preset.visibleColumns : []),
    ...presetCustomKeys,
  ]));

  const requiredFields = Array.from(new Set([
    ...baseRequiredFields,
    ...(Array.isArray(preset.requiredFields) ? preset.requiredFields : []),
  ]));

  return { visibleColumns, requiredFields, customColumns };
}
